import {
  ADD_CHAPTER_ERROR,
  ADD_CHAPTER_REQUEST,
  ADD_CHAPTER_SUCCESS,
} from 'storyboard/actions/add-chapter-actions';
import {
  ADD_LOGO_ERROR,
  ADD_LOGO_REQUEST,
  ADD_LOGO_SUCCESS,
} from 'storyboard/actions/add-logo-actions';
import {
  EDIT_CHAPTER_ERROR,
  EDIT_CHAPTER_REQUEST,
  EDIT_CHAPTER_SUCCESS,
} from 'storyboard/actions/edit-chapter-actions';
import {
  EDIT_THEME_ERROR,
  EDIT_THEME_REQUEST,
  EDIT_THEME_SUCCESS,
} from 'storyboard/actions/edit-theme-actions';
import {
  DELETE_CHAPTER_ERROR,
  DELETE_CHAPTER_REQUEST,
  DELETE_CHAPTER_SUCCESS,
} from 'storyboard/actions/delete-chapter-actions';
import {
  DELETE_LOGO_ERROR,
  DELETE_LOGO_REQUEST,
  DELETE_LOGO_SUCCESS,
} from 'storyboard/actions/delete-logo-actions';
import {
  POSITION_CHAPTERS_ERROR,
  POSITION_CHAPTERS_REQUEST,
  POSITION_CHAPTERS_SUCCESS,
} from 'storyboard/actions/position-chapter-actions';

export const request = {
  error: null,
  loading: true,
};

export const success = {
  error: null,
  loading: false,
};

export default (state = {}, action) => {
  switch (action.type) {
    case ADD_CHAPTER_REQUEST:
    case ADD_LOGO_REQUEST:
    case DELETE_CHAPTER_REQUEST:
    case DELETE_LOGO_REQUEST:
    case EDIT_CHAPTER_REQUEST:
    case EDIT_THEME_REQUEST:
    case POSITION_CHAPTERS_REQUEST:
      return {
        ...request,
        ...state,
      };

    case ADD_CHAPTER_ERROR:
    case ADD_LOGO_ERROR:
    case DELETE_CHAPTER_ERROR:
    case DELETE_LOGO_ERROR:
    case EDIT_CHAPTER_ERROR:
    case EDIT_THEME_ERROR:
    case POSITION_CHAPTERS_ERROR:
      return {
        ...state,
        error: action.error,
        loading: false,
      };

    case ADD_CHAPTER_SUCCESS:
      return {
        ...state,
        ...success,
        chapters: state.chapters.concat({
          ...action.chapter,
          justAdded: true,
        }),
      };
    case ADD_LOGO_SUCCESS:
      return {
        ...state,
        ...success,
        logo: action.logo.data.logo,
      };
    case DELETE_CHAPTER_SUCCESS:
      return {
        ...state,
        ...success,
        chapters: state.chapters.filter(
          (chapter) => chapter.id !== action.chapter.data.id,
        ),
      };
    case DELETE_LOGO_SUCCESS:
      return {
        ...state,
        ...success,
        logo: {},
      };
    case EDIT_CHAPTER_SUCCESS:
      return {
        ...state,
        ...success,
        chapters: state.chapters.map((chapter) =>
          chapter.id === action.chapter.data.id ? action.chapter.data : chapter,
        ),
      };
    case EDIT_THEME_SUCCESS:
      return {
        ...state,
        ...success,
        configuration: {
          ...state.configuration,
          ...action.storyboard.data.configuration,
        },
      };
    case POSITION_CHAPTERS_SUCCESS:
      return {
        ...state,
        ...success,
        // Incoming is a list of chapter IDs in the order
        // in which the user has positioned those chapters.
        // Sort chapters in memory based on this order:
        chapters: action.chapters.data.map((chapterId, index) => {
          for (const chapter of state.chapters) {
            if (chapter.id === chapterId) {
              return {
                ...chapter,
                position: index,
              };
            }
          }
          return null;
        }),
      };
    default:
      if (state.chapters) {
        return {
          ...state,
          chapters: state.chapters,
        };
      }
      return state;
  }
};
